import { render, staticRenderFns } from "./DeadEnd.vue?vue&type=template&id=1a525e44&scoped=true"
import script from "./DeadEnd.vue?vue&type=script&lang=js"
export * from "./DeadEnd.vue?vue&type=script&lang=js"
import style0 from "./DeadEnd.vue?vue&type=style&index=0&id=1a525e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a525e44",
  null
  
)

export default component.exports